import { LinkedContext } from '@context/LinkedItemZoneContext'
import { getProxyUrl } from '@proxies/index'
import { ReactMouseEvent, Textures } from '@types'

export default function handleCopy(
  ctx: Omit<LinkedContext, 'actions'>,
  property: Textures[number],
  e: ReactMouseEvent,
) {
  e.preventDefault()
  e.stopPropagation()

  fetch(
    getProxyUrl(
      `api/acabados/buscartexturaenunidad/${ctx.object?.current?.idUnidades}/${property.searchID}`,
    ),
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept-Language': 'ES',
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    },
  )
    .then((res) => res.json())
    .then((res2) => {
      ctx.setCopiedTexture(property)
      ctx.setCopiedIconId(property.zoneName)

      const newPasteIcons = Object.fromEntries(
        Object.entries(ctx.pasteIcons).map(([key, value]) => {
          return [key, 'cantPaste']
        }),
      )

      res2.forEach((el) => {
        const matchingZone = Object.keys(ctx.pasteIcons).find((zoneKey) =>
          zoneKey.includes(el.zona.trim()),
        )

        if (matchingZone && matchingZone !== property.zoneName) {
          newPasteIcons[matchingZone] = 'canPaste'
        }
      })

      ctx.setPasteIcons(newPasteIcons)
    })
    .catch((error) => {
      console.error('Error fetching texture:', error)
    })
  return
}
